import React, { useState, useEffect } from "react";
import { message as AndMessage, Spin } from "antd";
import { getTeamList, profilesetting } from "../../../fetch/api/login";

const ChooseTeam = ({ setAvatar }) => {
  const [loading, setLoading] = useState(true);
  const [team, setTeam] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [chooseTeam, setChooseTeam] = useState("");

  const getData = (key) => {
    getTeamList({ keyword: key }).then((res) => {
      if (res) {
        setLoading(false);
        const { code, data, message } = res;
        if (code == 200) {
          setTeam(data);
        } else {
          AndMessage.error({
            content: message,
            maxCount: 1,
          });
        }
      }
    });
  };
  useEffect(() => {
    getData(keyword);
  }, []);

  return (
    <Spin spinning={loading}>
      <div className=" w-full h-full flex flex-col items-center">
        <div className="mt-[15px] text-[13.5897px] font-bold">
          Choose your team
        </div>
        <div className=" flex items-center w-[219px] border border-[#BDBDBD] overflow-hidden h-[33px] rounded-[5px] font-semibold  mt-[19px] pl-[5px] pr-[5px]">
          <input
            maxLength="16"
            className="outline-0 w-full h-full text-[12px] font-medium placeholder:scale-[calc(8.7_/_12)] placeholder:origin-left"
            placeholder="Search team"
            value={keyword}
            onChange={(e) => {
              setKeyword(e.target.value);
              getData(e.target.value);
            }}
          />
        </div>
        <div className="w-[219px] h-[140px] mt-[20px] mb-[20px] flex flex-wrap overflow-y-auto">
          {team.map((item) => {
            return (
              <div
                key={item.ft_id}
                className=" flex flex-col items-center"
                title={item.team_name}
              >
                <div
                  className={`w-[40px] h-[40px] border shadow p-[7px] rounded-[6px] cursor-pointer  ${
                    chooseTeam.team_id == item.team_id
                      ? "border-[2px] border-[#09B251]"
                      : ""
                  }`}
                  style={{
                    boxShadow: "0px 3.74557px 6.08655px rgba(0, 0, 0, 0.16)",
                  }}
                  onClick={() => {
                    setChooseTeam(item);
                  }}
                >
                  <img className="w-full h-full" src={item.logo} />
                </div>
                <div
                  className={`w-[50px] overflow-hidden whitespace-nowrap text-center text-ellipsis scale-[calc(5.61_/_12)]  cursor-pointer ${
                    chooseTeam.team_id == item.team_id
                      ? "text-[#09B251]"
                      : "text-[#4F4F4F]"
                  }`}
                >
                  {item.team_name}
                </div>
              </div>
            );
          })}
        </div>
        <div
          className={`w-[219px] h-[30px] text-white  flex items-center justify-center rounded-[57px] m-auto mt-[17px]  cursor-pointer ${
            chooseTeam ? "bg-[#09B251]" : "bg-[#BDBDBD]"
          }`}
          onClick={() => {
            setLoading(true);
            profilesetting({ follow_teams: [chooseTeam.team_id] }).then(
              (res) => {
                if (res) {
                  const { code, data, message } = res;
                  setLoading(false);
                  if (code == 200) {
                    localStorage.setItem("login", JSON.stringify(data));
                    setAvatar();
                  } else {
                    AndMessage.error({
                      content: message,
                      maxCount: 1,
                    });
                  }
                }
              }
            );
          }}
        >
          <span className="scale-[calc(9.16_/_12)] text-[12px] font-semibold">
            CONTINUE
          </span>
        </div>
      </div>
    </Spin>
  );
};
export default ChooseTeam;
